import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { getCloudinaryUrl } from "@swiggy-private/js-utils";
import { BG_IMAGE_ID } from "./constants";

export const Container = styled.div(({ theme }) => {
    return {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing.medium,
        textAlign: "center",
        background: `url(${getCloudinaryUrl(BG_IMAGE_ID)})`,
        backgroundSize: "cover",
        backgroundColor: theme.colors[theme.colorMode].background_Primary,
    };
});

export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const ImageContainer = styled.div(({ theme }) => {
    return {
        width: "250px",
        height: "250px",
        marginBottom: theme.spacing.xSmall,
    };
});

export const Title = styled(Text)(({ theme }) => {
    return {
        marginBottom: theme.spacing.xSmall,
    };
});

export const Subtitle = styled(Text)(({ theme }) => {
    return {
        marginBottom: theme.spacing.medium,
    };
});

export const ButtonContainer = styled.div(({ theme }) => {
    return {
        margin: "auto",
        marginTop: theme.spacing.xLarge,
        width: "70%",
        maxWidth: "300px",
    };
});

export const PrimaryAction = styled(FullWidthButton)(() => {
    return {
        width: "100%",
    };
});

export const SecondaryAction = styled(FullWidthButton)(({ theme }) => {
    return {
        width: "100%",
        marginTop: theme.spacing.medium,
    };
});
